module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lScEu"))).then(() => module.bundle.root('jnagv'));